import TeaserListModel from 'models/properties/teaserListModel';
import {Collection, Model} from 'backbone';
import {applyEdits} from './data';

const TeaserListCollection = Collection.extend({model: TeaserListModel});
export default Model.extend({
    urlRoot: '/api/facade_teaserPage',
    idAttribute: 'uuid',
    edits: null,
    defaults: {
        teaserLists: null,
    },
    initialize() {
        this.edits = [];
    },
    parse(data) {
        let model = {};

        if (data && Object.getOwnPropertyNames(data).length > 0) {
            if (data.success === false) {
                return false;
            }
            data = data.hasOwnProperty('data') ? data.data : data;
            model = (data instanceof Array) ? {...data[0]} : {...data};
            model.teaserLists = new TeaserListCollection(model.teaserLists);
        }

        return model;
    },
    save(attrs, options) {
        const that = this;
        options = options || {};
        const origSuccess = options.success || Boolean;
        if (!that.edits.length) {
            origSuccess.call(options.context || that, that, {success: true, mismatches: []}, options);
            return;
        }
        that.fetch({
            reset: true,
            success() {
                options.mismatches = that._applyEdits();
                options.success = function() {
                    that.edits = [];
                    origSuccess.apply(options.context, arguments);
                };
                Model.prototype.save.call(that, attrs, options);
            },
            failure() {
                if (options.failure) {
                    options.failure.apply(options.context, arguments);
                }
            },
        });
    },
    _applyEdits() {
        const collection = this.get('teaserLists');
        const {teaserLists, mismatches} = applyEdits(collection.toJSON(), this.edits);
        collection.reset(teaserLists);
        return mismatches;
    },
});
